export default __webpack_public_path__ + "static/media/productDiscount.0d502298.webp";